import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './Modal';
import { ModalTransitionConsumer } from './ModalTransition';
import StackConsumer from './StackConsumer';
export default function ModalWrapper(props) {
    const { onCloseComplete, stackIndex, children, shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick = true, width = 'medium', size = 'medium', root = document.body, } = props;
    const onModalClosed = (onExited) => (e) => {
        onExited === null || onExited === void 0 ? void 0 : onExited();
        onCloseComplete === null || onCloseComplete === void 0 ? void 0 : onCloseComplete(e);
    };
    return (React.createElement(ModalTransitionConsumer, null, ({ isOpen, onExited }) => ReactDOM.createPortal(React.createElement(StackConsumer, { isOpen: isOpen }, (naturalStackIndex) => (React.createElement(Modal, Object.assign({}, props, { size: size, shouldCloseOnEscapePress: shouldCloseOnEscapePress, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, width: width, isOpen: isOpen, stackIndex: stackIndex || naturalStackIndex, onCloseComplete: onModalClosed(onExited) }), children))), root)));
}
//# sourceMappingURL=ModalWrapper.js.map